import React from 'react';
import { Svg } from '@jg/components';
import rocknroll from 'assets/svg/rocknroll-logo.svg';

import './CobrandedHeader.scss';

export default () => (
  <div className="cobranded-header">
    <div className="cobranded-header__inner container">
      <Svg markup={rocknroll} alt="Rock 'n' Roll" className="cobranded-header__rocknroll-logo" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/CobrandedHeader/CobrandedHeader.js